module.exports = __webpack_public_path__ + "static/media/fundacion-botin.e6c2c9eb.jpg";